// extracted by mini-css-extract-plugin
module.exports = {"card":"aed17b9412--card--QbVuw","phone":"aed17b9412--phone--y4iz2","heading":"aed17b9412--heading--bB8Xv","description":"aed17b9412--description--ruOtX"};